import React from 'react';
import { Mic, MicOff } from 'lucide-react';
import { Box, useTheme } from '@mui/material';

const RecordingIndicator = ({ outerSize = 140, innerSize = 116, iconSize = '80px', recording, disabled = false }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: outerSize,
        height: outerSize,
        borderRadius: '50%',
        bgcolor: recording ? theme.palette.secondary.main : disabled ? '#EDEDED' : '#D8D8D8',
        boxShadow: recording
          ? `0px 3px 4px 0px rgba(0, 0, 0, 0.25) inset, 0px 0px 10px ${theme.palette.secondary.main}`
          : '0px 3px 4px 0px rgba(0, 0, 0, 0.25) inset, 0px 0px 10px rgb(195, 195, 195)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: innerSize,
          height: innerSize,
          borderRadius: '50%',
          bgcolor: 'white',
          boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden', // Ensures inner element is clipped to circle
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            background: 'linear-gradient(0deg, #E4E4E4, #ffffff)',
            WebkitMask:
              'radial-gradient(circle, transparent calc(54px), black calc(4px))',
            pointerEvents: 'none',
            transform: 'translateZ(0)',
          }}
        />
        {recording ? (
          <Mic
            size={iconSize}
            style={{
              strokeWidth: 1.4,
              color: recording ? 'inherit' : '#A1A1AA',
            }}
          />
        ) : (
          <MicOff
            size={iconSize}
            style={{
              strokeWidth: 1.4,
              color: recording ? 'inherit' : disabled ? '#EDEDED' : '#A1A1AA',
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default RecordingIndicator;
